//consider adding memory fallback if cookie is disabled
//not meant to be a full replacement for localStorage
export default {
  getItem(key) {
    if (!key)
      return

    const match = (new RegExp('(' + key + ')=([^;]*)')).exec(document.cookie)
    if (match)
      return match[2]
    else
      return

  },
  setItem(key, value) {
    if (!key && value && typeof value == 'string')
      return
    const expire = new Date()
    //console.log(key + '=' + value + '; expires=' + expire.setDate(expire.getDate() + 30) + '; path=/')
    document.cookie = key + '=' + value + '; expires=' + expire.setDate(expire.getDate() + 30) + '; path=/'
  },
  removeItem(key) {
    if (!key)
      return

    document.cookie = key + '=; expires=-1; path=/'
  },
  isCookie: true
}
